import { mapGetters } from "vuex";
import pageheader from "../../pageheader";
import utils from "../../../utils/util";
import telematicsService from "../../../api/telematics.service";
import moment from "moment";
export default {
  name: "geo-fences-list",
  components: { pageheader },
  data() {
    return {
      input: {},
      dialog: false,
      selectedGeofence: {},
      headers: [
        {
          text: "#",
          align: "center",
          sortable: false,
          value: "sno",
        },
        { text: "Company Name", value: "customerName" },
        { text: "User Email", value: "createdBy" },
        { text: "Name", value: "name" },
        { text: "Description", value: "description" },
        { text: "Created Date", value: "createdDate" },
        { text: "Action", value: "action", width: "120px" },
      ],
      search: "",
      options: {},
      loading: false,
      geofences: [],
      isdelete: false,
      isFilter: false,
    };
  },
  computed: {
    ...mapGetters(["roles", "id"]),
  },
  filters: {
    formatDate: function (value) {
      if (value) {
        const format = "MM/DD/YYYY hh:mm:ss A";
        return moment(value).format(format);
      }
    },
    formattoLocalDate: function (value) {
      if (value) {
        const format = "MM/DD/YYYY hh:mm:ss A";
        return moment.utc(value).local().format(format);
      }
    },
  },
  mounted() {
    this.input = utils.getInputContent("geofences", this.roles);
    if (this.$route.query && this.$route.query.isFilter) {
      this.search = this.$route.query.filterVal;
      this.isFilter = this.$route.query.isFilter;
    }
    this.getGeofences();
  },
  methods: {
    confirmDelete(item) {
      this.dialog = true;
      this.selectedGeofence = item;
    },
    newGeofence() {
      this.$router.push({
        path: "/geofences/add",
      });
    },
    async getGeofences() {
      this.geofences = [];
      this.loading = true;
      try {
        let response = await telematicsService.getGeofences();
        if (response && response.data) {
          this.geofences = response.data.map((d, index) => ({
            ...d,
            sno: index + 1,
          }));
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async deleteGeofence() {
      try {
        this.isdelete = true;
        let response = await telematicsService.deleteGeofence(
          this.selectedGeofence.id
        );
        if (response.isSuccess) {
          this.isdelete = false;
          this.$toast.success("Geofence deleted successfully");
          this.getGeofences();
          this.dialog = false;
          this.selectedGeofence = {};
        } else {
          this.isdelete = false;
          this.$toast.success(response.systemMessage);
        }
      } catch (err) {
        this.isdelete = false;
        this.$toast.error("Unable to delete Geofence" + err);
      }
    },
    editGeofence(item) {
      this.$router.push({
        name: "Update Geofences",
        params: { id: item.id },
        query: {
          filterVal: this.isFilter ? this.search : "",
          isFilter: this.isFilter,
        },
      });
    },
    onSearch() {
      if (this.search) {
        this.isFilter = true;
      } else {
        this.isFilter = false;
      }
    },
    clearSearch() {
      this.search = "";
      this.$router.replace(`/geofences/list`);
      this.getGeofences();
    },
  },
};
